import { Injectable } from '@angular/core';
import { combineLatest, map, Observable, ReplaySubject } from 'rxjs';
import { GooglePayProperties } from '../api/api.models';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleComposerService {
  private $properties = new ReplaySubject<GooglePayProperties>(1);

  private baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
  };

  private $tokenizationSpecification = this.$properties.pipe(
    map((props) => ({
      type: 'DIRECT',
      parameters: {
        protocolVersion: 'ECv2',
        publicKey: props.publicKeyBase64,
      },
    }))
  );

  public readonly baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
      allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'], // All possible networks
    },
  };

  private $cardPaymentMethod = this.$tokenizationSpecification.pipe(
    map((tokenizationSpecification) => ({
      tokenizationSpecification: tokenizationSpecification,
      ...this.baseCardPaymentMethod,
    }))
  );

  private transactionInfo = {
    totalPriceStatus: 'FINAL',
    totalPrice: '0',
    currencyCode: 'EUR',
    countryCode: 'EE',
  };

  private $merchantInfo = this.$properties.pipe(
    map((props) => ({
      merchantName: props.merchantName,
      merchantId: props.merchantId,
    }))
  );

  public readonly $paymentDataRequest: Observable<google.payments.api.PaymentsRequest> = combineLatest([
    this.$cardPaymentMethod,
    this.$merchantInfo,
  ]).pipe(
    map(([cardPaymentMethod, merchantInfo]) => ({
      ...this.baseRequest,
      allowedPaymentMethods: [cardPaymentMethod],
      transactionInfo: this.transactionInfo,
      merchantInfo: merchantInfo,
    }))
  );

  public readonly isReadyToPayRequest: google.payments.api.PaymentsRequest = {
    ...this.baseRequest,
    allowedPaymentMethods: [this.baseCardPaymentMethod],
  };

  constructor(private apiService: ApiService) {
    this.apiService.getGoogleProperties().subscribe((properties) => this.$properties.next(properties));
  }
}
